/** Sectors that typically do not need the manufacturing workflow planner. */
const NON_MANUFACTURING_INDUSTRY_PATTERN =
  /\b(services?|trading|retail|wholesale|it\b|information technology|software|consulting|hospitality|healthcare|education|logistics only|e-?commerce|professional)\b/i;

export const isNonManufacturingSector = (industry?: string | null, companyType?: string | null): boolean => {
  const combined = `${industry || ''} ${companyType || ''}`.trim();
  if (!combined) {
    return false;
  }
  return NON_MANUFACTURING_INDUSTRY_PATTERN.test(combined);
};

export const hasCompletedWorkflowPlanner = (workflow: any): boolean => {
  if (!workflow || typeof workflow !== 'object') {
    return false;
  }

  const units = Array.isArray(workflow.units) ? workflow.units : [];
  const hasUnitProcesses = units.some((unit: any) => {
    const processes = Array.isArray(unit?.processes) ? unit.processes : [];
    return processes.length > 0;
  });

  const legacyProcesses = Array.isArray(workflow.processes) ? workflow.processes : [];
  const hasAnyProcesses = hasUnitProcesses || legacyProcesses.length > 0;

  return Boolean(workflow.lastEstimatedAt) && hasAnyProcesses;
};
